import React from 'react'
import {
    Box,
    Typography,
    Modal,
    Card,
    CardContent,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Grid,
    Tooltip,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Badge, { badgeClasses } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import { Button, IconButton } from '@mui/material';
import { PlayArrow, Pause, NavigateNext, NavigateBefore } from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import APIAxios from "../../Api/APIAxios";
import { useEffect, useState } from "react";
import { PostAPI } from '../../Components/Backend/PostAPI';
import CircularProgress from '@mui/material/CircularProgress';

const URL_Image = "/image";
const URL_Image_Download = "/image/download";
const URL_Zip_Download = "/images/zip";
const URL_Images = "/images";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "70%",
    bgcolor: '#D3D3D3',
    border: '2px solid #000',
    boxShadow: 24,

};

const UserDashboardImagens = ({ user, dia, hora, exibeVideos, abrirVideo }) => {

    const [error, setError] = useState("");
    const [donwloadProgress, setDownloadProgress] = useState(false);
    const [numMonitor, setNumMonitor] = useState(1);
    const [isPlaying, setIsPlaying] = useState(false);
    const [intervalo, setIntervalo] = useState(1000);
    const [velocidade, setVelocidade] = useState("1X");
    const [imagens1, setImagens1] = useState([]);
    const [imagens2, setImagens2] = useState([]);
    const [imagens3, setImagens3] = useState([]);
    const [imagens4, setImagens4] = useState([]);
    const [imagensID1, setImagensID1] = useState([]);
    const [imagensID2, setImagensID2] = useState([]);
    const [imagensID3, setImagensID3] = useState([]);
    const [imagensID4, setImagensID4] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [imagensCarregadas, setImagensCarregadas] = useState([]);

    const apiAxios = APIAxios();

    //Carregar imagens quando alguém selecionar o dia
    //Resultado: carrega o caminho das imagens (URL)
    useEffect(() => {
        if (exibeVideos) {
            handleOpen();
            carregarImagens()
        }
    }, [abrirVideo]);


    const carregarImagens = async () => {

        setLoading(true);
        setError("");

        //Limpa registros de imagens
        setImagens1([]);
        setImagens2([]);
        setImagens3([]);
        setImagens4([]);
        setImagensID1([]);
        setImagensID2([]);
        setImagensID3([]);
        setImagensID4([]);

        //Carrega identificação das imagens
        const response = await PostAPI(apiAxios, URL_Images,
            {
                data_inicio: dia,
                data_fim: dia,
                id_usuario: user.idColaborador,
            });

        if (response.success) {

            const idImagens = response.data;

            //Trata registro
            if (idImagens.length > 0) {

                const tempIDs = [];
                const tempMons = [];

                idImagens.map((registro) => {
                    if (registro.data === dia) {
                        if (registro.hora.slice(0, 2) === hora) {
                            tempIDs.push(registro.id);
                            tempMons.push(registro.monitor);
                        }
                    }
                });

                //Faz download das imagens
                try {

                    let cont = 1;
                    const tempImgs1 = [];
                    const tempImgs2 = [];
                    const tempImgs3 = [];
                    const tempImgs4 = [];
                    const tempId1 = [];
                    const tempId2 = [];
                    const tempId3 = [];
                    const tempId4 = [];

                    for (const imgReg of tempIDs) {

                        setProgress(cont * 100 / tempIDs.length);

                        try {
                            // Chamada assíncrona para buscar a imagem
                            const response = await apiAxios.get(URL_Image + "/" + imgReg, {
                                responseType: "blob",
                            });

                            // Cria uma URL temporária para o blob recebido
                            const blogImage = URL.createObjectURL(response.data);

                            if (tempMons[cont - 1] === 0) {
                                tempImgs1.push(blogImage); // Adiciona ao array temporário
                                tempId1.push(imgReg);
                            }
                            if (tempMons[cont - 1] === 1) {
                                tempImgs2.push(blogImage); // Adiciona ao array temporário
                                tempId2.push(imgReg);
                            }
                            if (tempMons[cont - 1] === 2) {
                                tempImgs3.push(blogImage); // Adiciona ao array temporário
                                tempId3.push(imgReg);
                            }
                            if (tempMons[cont - 1] === 3) {
                                tempImgs4.push(blogImage); // Adiciona ao array temporário
                                tempId4.push(imgReg);
                            }
                        } catch (err) {
                        }
                        cont = cont + 1;
                    }

                    //Controle de IDs
                    setImagensID1(tempId1);
                    setImagensID2(tempId2);
                    setImagensID3(tempId3);
                    setImagensID4(tempId4);

                    //Controle de Imagens
                    setImagens2(tempImgs2);
                    setImagens3(tempImgs3);
                    setImagens4(tempImgs4);

                    //Deixar imagem1 por último, pois é utilizado em outros processos.
                    setImagens1(tempImgs1);

                } catch (err) {
                    if (!err.response) {
                        setError("Servidor não responde");
                    } else if (err.response.status === 400 || err.response.status === 401) {
                        setError(err.response.data.erro);
                    } else {
                        setError("Erro desconhecido.");
                    }
                } finally {
                    setLoading(false);
                }
            }

        } else {
            setError(response.errorMessage || "Erro ao carregar imagens.");
        }
        setLoading(false);
    };
    // -----------------------------------------------------------------------------------


    // ******************************* CONTROLE DE NAVEGAÇÃO
    // Quando atualiza as imagens volta o posicionamento
    useEffect(() => {
        setCurrentIndex(0);
    }, [imagens1]);

    const handlePlayPause = () => {
        setIsPlaying((prev) => !prev);
    };

    useEffect(() => {
        if (isPlaying && numMonitor === 1 && currentIndex % imagens1.length === imagens1.length - 1) {
            handlePlayPause();
        }
        if (isPlaying && numMonitor === 2 && currentIndex % imagens2.length === imagens2.length - 1) {
            handlePlayPause();
        }
        if (isPlaying && numMonitor === 3 && currentIndex % imagens3.length === imagens3.length - 1) {
            handlePlayPause();
        }
        if (isPlaying && numMonitor === 4 && currentIndex % imagens4.length === imagens4.length - 1) {
            handlePlayPause();
        }
    }, [currentIndex]);

    const handleNext = () => {
        if (numMonitor === 1) {
            if ((currentIndex + 1) % imagens1.length === 0 && currentIndex !== 0) {
                setCurrentIndex(0);
                setIsPlaying(false);
            }
            setCurrentIndex((prevIndex) => (prevIndex + 1) % imagens1.length);
        }
        if (numMonitor === 2) {
            if ((currentIndex + 1) % imagens2.length === 0 && currentIndex !== 0) {
                setCurrentIndex(0);
                setIsPlaying(false);
            }
            setCurrentIndex((prevIndex) => (prevIndex + 1) % imagens2.length);
        }
        if (numMonitor === 3) {
            if ((currentIndex + 1) % imagens3.length === 0 && currentIndex !== 0) {
                setCurrentIndex(0);
                setIsPlaying(false);
            }
            setCurrentIndex((prevIndex) => (prevIndex + 1) % imagens3.length);
        }
        if (numMonitor === 4) {
            if ((currentIndex + 1) % imagens4.length === 0 && currentIndex !== 0) {
                setCurrentIndex(0);
                setIsPlaying(false);
            }
            setCurrentIndex((prevIndex) => (prevIndex + 1) % imagens4.length);
        }
    };

    const handlePrev = () => {
        if (numMonitor === 1) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + imagens1.length) % imagens1.length);
        }
        if (numMonitor === 2) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + imagens2.length) % imagens2.length);
        }
        if (numMonitor === 3) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + imagens3.length) % imagens3.length);
        }
        if (numMonitor === 4) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + imagens4.length) % imagens4.length);
        }
    };

    const handleRapido = () => {
        switch (intervalo) {
            case 2000:
                setIntervalo(1500);
                setVelocidade("0,75X");
                break;
            case 1500:
                setIntervalo(1000);
                setVelocidade("1X");
                break;
            case 1000:
                setIntervalo(750);
                setVelocidade("1,5X");
                break;
            case 750:
                setIntervalo(500);
                setVelocidade("2X");
                break;
        }
    }

    const handleDevagar = () => {
        switch (intervalo) {
            case 500:
                setIntervalo(750);
                setVelocidade("1,5X");
                break;
            case 750:
                setIntervalo(1000);
                setVelocidade("1X");
                break;
            case 1000:
                setIntervalo(1500);
                setVelocidade("0,75X");
                break;
            case 1500:
                setIntervalo(2000);
                setVelocidade("0,5X");
                break;
        }
    }

    useEffect(() => {
        if (numMonitor === 1) {
            setCurrentIndex((prevIndex) => prevIndex % imagens1.length);
        }
        if (numMonitor === 2) {
            setCurrentIndex((prevIndex) => prevIndex % imagens2.length);
        }
        if (numMonitor === 3) {
            setCurrentIndex((prevIndex) => prevIndex % imagens3.length);
        }
        if (numMonitor === 4) {
            setCurrentIndex((prevIndex) => prevIndex % imagens4.length);
        }
    }, [numMonitor]);

    useEffect(() => {
        let timer;
        if (isPlaying) {
            timer = setInterval(() => {
                handleNext();
            }, intervalo);
        }
        return () => clearInterval(timer);
    }, [isPlaying, imagens1.length, intervalo]);

    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);

    const handleClose = () => {
        setIsPlaying(false);
        setOpen(false);
    }

    function valueMonitor(event) {
        setNumMonitor(event.target.value);
    }

    const CartBadge = styled(Badge)`& .${badgeClasses.badge} { top: 20px; right:-12px}`;

    //Download Imagem - precisa ser async
    const handleDownloadUnico = async () => {
        try {
            setLoading(true);

            //Identifica o ID da Imagem
            const idImg =
                (numMonitor === 1 && imagensID1[currentIndex]) ||
                (numMonitor === 2 && imagensID2[currentIndex]) ||
                (numMonitor === 3 && imagensID3[currentIndex]) ||
                (numMonitor === 4 && imagensID4[currentIndex]);

            if (!idImg) return;

            //Faz download do arquivo
            const response = await apiAxios.get(`${URL_Image_Download}/${idImg}`, {
                responseType: "blob"
            });

            setLoading(false);

            //Identifica o nome do arquivo no servidor
            const cd = response.headers["content-disposition"] || "";
            let filename = `imagem_${idImg}`;

            let match = cd.match(/filename="([^"]+)"/i);
            if (match?.[1]) {
                filename = match[1];
            } else {
                // cobre: filename=abc.jpg (sem aspas)
                match = cd.match(/filename=([^;]+)/i);
                if (match?.[1]) filename = match[1].trim();
            }

            //Grava o download
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };


    const handleDownloadTodos = async () => {
        try {
            setDownloadProgress(true);

            const payload = {
                data_inicio: dia,
                data_fim: dia,
                id_usuario: user.idColaborador,
            };

            //Faz download do arquivo
            const response = await apiAxios.post(`${URL_Zip_Download}`, payload,
                {
                    responseType: "blob",
                }
            );
            setDownloadProgress(false);

            //Identifica o nome do arquivo no servidor
            const cd = response.headers["content-disposition"] || "";
            let filename = `arquivo.zip`;

            let match = cd.match(/filename="([^"]+)"/i);
            if (match?.[1]) {
                filename = match[1];
            } else {
                // cobre: filename=abc.jpg (sem aspas)
                match = cd.match(/filename=([^;]+)/i);
                if (match?.[1]) filename = match[1].trim();
            }

            //Grava o download
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setDownloadProgress(false);
            // Quando responseType é "blob", até erro vem como Blob
            if (err?.response?.data instanceof Blob) {
                const text = await err.response.data.text();
                // opcional: tentar parsear JSON
            }
        } finally {
            setDownloadProgress(false);
        }
    };

    return (
        <div>
            <Modal
                open={open}
            >
                <Box>
                    {loading && (
                        <Box
                            sx={{ mt: 4, width: "50%", margin: "auto", alignItems: "center" }} >
                            <Card sx={{ width: "100%", boxShadow: 3 }}>
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <Typography variant="h6" gutterBottom align="center">
                                                Carregando Imagens do dia {dia} às {hora} horas.
                                            </Typography>
                                            <LinearProgress variant="determinate" value={progress} />

                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                {`${Math.round(progress)}%`}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                        <Button
                                            onClick={handleClose}
                                            variant="contained"
                                            color="error"
                                            startIcon={<CloseIcon />}
                                            sx={{ mx: 2 }}
                                        >
                                            Fechar
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {!loading && (
                        <Box>
                            <Box sx={style}>
                                <Card
                                    sx={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        boxShadow: 3,
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <CardContent>
                                        <Box>
                                            <Box textAlign="center" p={2}>
                                                {(
                                                    (imagens1.length === 0 && numMonitor === 1) ||
                                                    (imagens2.length === 0 && numMonitor === 2) ||
                                                    (imagens3.length === 0 && numMonitor === 3) ||
                                                    (imagens4.length === 0 && numMonitor === 4)
                                                ) && (
                                                        <Typography variant="h6" align="center" sx={{ mt: 4 }}>
                                                            Nenhuma imagem disponível para o horário e monitor selecionados.
                                                        </Typography>
                                                    )}
                                                {(
                                                    (imagens1.length > 0 && numMonitor === 1) ||
                                                    (imagens2.length > 0 && numMonitor === 2) ||
                                                    (imagens3.length > 0 && numMonitor === 3) ||
                                                    (imagens4.length > 0 && numMonitor === 4)
                                                ) && (
                                                        <Box
                                                            sx={{
                                                                width: "100%",
                                                                height: "70vh",          // altura fixa pra área da imagem
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                overflow: "hidden",
                                                                mb: 2,
                                                            }}
                                                        >
                                                            <Box
                                                                component="img"
                                                                src={
                                                                    (numMonitor === 1 && (imagens1[currentIndex])) ||
                                                                    (numMonitor === 2 && (imagens2[currentIndex])) ||
                                                                    (numMonitor === 3 && (imagens3[currentIndex])) ||
                                                                    (numMonitor === 4 && (imagens4[currentIndex]))
                                                                }
                                                                alt={`Slide ${currentIndex}`}
                                                                sx={{
                                                                    maxWidth: "100%",
                                                                    maxHeight: "100%",
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    objectFit: "contain",
                                                                    borderRadius: 2,
                                                                    boxShadow: 3,
                                                                }}
                                                            />
                                                        </Box>
                                                    )}
                                                <Grid container >
                                                    <Grid md={2} lg={2}>
                                                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                                            <FormControl fullWidth size="small" color="primary">
                                                                <InputLabel id="demo-simple-select-label" color="primary">Monitor</InputLabel>
                                                                <Select
                                                                    labelId="monitor"
                                                                    id="monitor"
                                                                    value={numMonitor}
                                                                    label="Monitor"
                                                                    onChange={valueMonitor}
                                                                    color="primary"
                                                                >
                                                                    <MenuItem value={1} color="primary">Monitor 1</MenuItem>
                                                                    <MenuItem value={2} disabled={imagens2.length === 0} color="primary">Monitor 2</MenuItem>
                                                                    <MenuItem value={3} disabled={imagens3.length === 0} color="primary">Monitor 3</MenuItem>
                                                                    <MenuItem value={4} disabled={imagens4.length === 0} color="primary">Monitor 4</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                    </Grid>
                                                    <Grid md={8} lg={8}>
                                                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                                            {isPlaying && (
                                                                <IconButton onClick={handleDevagar} aria-label="Devagar" disabled={intervalo === 2000}>
                                                                    <FastRewindIcon />
                                                                </IconButton>
                                                            )}
                                                            {!isPlaying && (
                                                                <IconButton onClick={handlePrev} aria-label="Previous">
                                                                    <NavigateBefore />
                                                                </IconButton>
                                                            )}
                                                            <Button
                                                                onClick={handlePlayPause}
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={isPlaying ? <Pause /> : <PlayArrow />}
                                                                sx={{ mx: 2 }}
                                                            >
                                                                {isPlaying && (
                                                                    <CartBadge badgeContent={velocidade} color="info" overlap="circular" />
                                                                )}
                                                                {isPlaying ? 'Pause' : 'Play'}
                                                            </Button>
                                                            {!isPlaying && (
                                                                <IconButton onClick={handleNext} aria-label="Next">
                                                                    <NavigateNext />
                                                                </IconButton>
                                                            )}
                                                            {isPlaying && (
                                                                <IconButton onClick={handleRapido} aria-label="Rápido" disabled={intervalo === 500}>
                                                                    <FastForwardIcon />
                                                                </IconButton>
                                                            )}

                                                            {/* --- Botões de Download --- */}
                                                            <Box sx={{ ml: 4, display: 'flex', gap: 1 }}>
                                                                <Tooltip title="Download imagem atual">
                                                                    <IconButton
                                                                        onClick={handleDownloadUnico}
                                                                        color="primary"
                                                                        size="small">
                                                                        <DownloadIcon />
                                                                    </IconButton>
                                                                </Tooltip>

                                                                <Tooltip title="Download de todas as imagens deste horário">
                                                                    {donwloadProgress && <CircularProgress size={20} />}
                                                                    {!donwloadProgress && (
                                                                        <IconButton onClick={handleDownloadTodos} color="primary" size="small">
                                                                            <CloudDownloadIcon />
                                                                        </IconButton>
                                                                    )}
                                                                </Tooltip>
                                                            </Box>
                                                        </Box>

                                                    </Grid>
                                                    <Grid md={2} lg={2}>
                                                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                                            <Button
                                                                onClick={handleClose}
                                                                variant="contained"
                                                                color="error"
                                                                startIcon={<CloseIcon />}
                                                                sx={{ mx: 2 }}
                                                            >
                                                                Fechar
                                                            </Button>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Box >
                    )}
                </Box >
            </Modal >

        </div >
    )
}

export default UserDashboardImagens
